<template>
  <v-row justify="space-around">
    <v-col
      cols="auto"
      v-for="topMeasurement in topMeasurements"
      :key="topMeasurement.fullForm"
    >
      <v-card outlined>
        <v-container>
          <v-row no-gutters>
            <v-col cols="auto" justify-self="center" align-self="center">
              <v-icon color="primary" left x-large>
                {{ topMeasurement.icon }}
              </v-icon>
            </v-col>
            <v-col cols="auto" align-self="auto">
              <span class="caption text-uppercase">
                {{ topMeasurement.fullForm }}
              </span>
              <br />
              {{ topMeasurement.value }} {{ topMeasurement.unit }}
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'top-metrics',
  props: {
    deviceType: {
      type: String,
      required: true
    },
    currentMeasurements: {
      type: Object,
      required: true
    },
    waterOutput: {
      type: Number
    },
    fault: {
      type: String
    },
    isEcofrostV4: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    topMeasurements() {
      if (this.deviceType === 'ecotron') {
        return [
          {
            fullForm: 'Power',
            icon: 'mdi-solar-power',
            value: parseFloat(this.currentMeasurements.OPW).toFixed(2),
            unit: 'kW'
          },
          {
            fullForm: 'Voltage',
            icon: 'mdi-power-plug',
            value: parseFloat(this.currentMeasurements.DCV).toFixed(2),
            unit: 'V'
          },
          {
            fullForm: 'Current',
            icon: 'mdi-flash',
            value: parseFloat(this.currentMeasurements.DCI).toFixed(2),
            unit: 'A'
          },
          {
            fullForm: 'Frequency',
            icon: 'mdi-gauge',
            value: parseFloat(this.currentMeasurements.OPF).toFixed(2),
            unit: 'Hz'
          },
          {
            fullForm: 'Water',
            icon: 'mdi-water',
            value: parseFloat(this.waterOutput).toFixed(2),
            unit: 'lpm'
          }
        ];
      } else if (this.deviceType === 'ecofrost') {
        const room1Temp = this.isEcofrostV4
          ? this.currentMeasurements.MCU_RM1_TEMP
          : this.currentMeasurements.Room_1_T;
        const room2Temp = this.isEcofrostV4
          ? this.currentMeasurements.MCU_RM2_TEMP
          : this.currentMeasurements.Room_2_T;
        const room1Humidity = this.isEcofrostV4
          ? this.currentMeasurements.MCU_RM1_HUM
          : this.currentMeasurements.Room_1_H;

        return [
          {
            fullForm: 'R1 Temp',
            icon: 'mdi-thermometer',
            value: parseFloat(room1Temp).toFixed(2),
            unit: '°C'
          },
          {
            fullForm: 'R2 Temp',
            icon: 'mdi-thermometer',
            value: parseFloat(room2Temp).toFixed(2),
            unit: '°C'
          },
          {
            fullForm: 'R1 Humidity',
            icon: 'mdi-water-percent',
            value: parseFloat(room1Humidity).toFixed(2),
            unit: '%'
          },
          {
            fullForm: 'Door',
            icon: 'mdi-door',
            value: this.doorStatus
          },
          {
            fullForm: 'Faults',
            icon: 'mdi-alert-circle',
            value: this.fault
          }
        ];
      } else {
        return [];
      }
    },
    doorStatus() {
      // checking device type
      if (this.deviceType === 'ecofrost') {
        if (this.isEcofrostV4) {
          const room1Door = parseInt(
            this.currentMeasurements.MCU_RM1_DR_ST,
            10
          );
          const room2Door = parseInt(
            this.currentMeasurements.MCU_RM2_DR_ST,
            10
          );

          if (room1Door === 1 || room2Door === 1) {
            return 'Open';
          }
          if (room1Door === 0 && room2Door === 0) {
            return 'Closed';
          }
          return 'Error';
        }

        // checking door status
        let status = parseInt(this.currentMeasurements.Door_Stat, 2);
        if (status === 0) {
          return 'Closed';
        } else if (status === 1) {
          return 'Open';
        } else {
          return 'Error';
        }
      } else {
        return null;
      }
    }
  }
};
</script>
